module.exports = __webpack_public_path__ + "static/media/default-news-image-1.d324c6b7.png";